import { ReturnTranslatedText } from '@wajeez-web/core/localization';
export const seperator = () => {
  return (
    <div className="py-5 relative ">
      <div
        className="absolute border-s border-gray-50 w-1 bottom-0 top-0  border-solid"
        style={{ zIndex: -1 }}
      ></div>
      <div
        data-testid="tag"
        className="font-medium rounded-full  inline-block border border-solid bg-gray-50 text-gray-600 text-center border-gray-50 text-sm px-4 py-1"
      >
        <div className="flex w-full text-center items-center">
          <div className=" text-center flex items-center first:ms-0">
            <ReturnTranslatedText origintext="AND" text={`general.AND`} />
          </div>
        </div>
      </div>
    </div>
  );
};
